import { InsightsSummaryDataKpi } from '../model/insights-summary-data-kpi.model';

export function defaultSummaryKpi(): InsightsSummaryDataKpi {
    return {
        kpiValue: null,
    };
}
